import * as firebaseSdk from 'sdk/firebase'
import * as LocalStorageUtils from 'utils/local-storage'
import * as React from 'react'

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger,
} from 'components/ui/dropdown-menu'

import { AuthContext } from 'providers/auth-provider'
import IconButton from './icon-button'
import { UserCircle2 } from 'lucide-react'

function ProfileMenu({}) {
    const { removeUser } = React.useContext(AuthContext)

    const logoutUser = async () => {
        await firebaseSdk.logout()
        LocalStorageUtils.clearStorage()
        removeUser()
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger>
                <IconButton className=" aspect-square px-0" tooltip="Menù Utente">
                    <UserCircle2 />
                </IconButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-white  flex flex-col items-start px-6 mr-3">
                <DropdownMenuLabel>Profilo</DropdownMenuLabel>
                <DropdownMenuItem className="cursor-pointer hover:bg-slate-950" onClick={logoutUser}>
                    Logout
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

export default ProfileMenu
